var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tabList"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:'t' + index,staticClass:"tabItem",class:{ active: _vm.$route.path.includes(item.name) },on:{"click":function($event){return _vm.handleChange(item.name)}}},[_vm._v(_vm._s(item.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }